/* eslint-disable @stylistic/padding-line-between-statements */
import {inject, Injectable} from '@angular/core';
import {PaymentChargeStore} from './payment-charge.store';
import {Payment} from '@features/payment/domain/entities/payment.entity';
import {PaymentDTO} from '@features/payment/domain/model/payment.model';

@Injectable({providedIn: 'root'})
export class PaymentQueryService {
  private readonly store = inject(PaymentChargeStore);

  getAllDtos(): PaymentDTO[] {
    return this.store.state().payments;
  }

  getDtoByOrderId(orderId: string): PaymentDTO | undefined {
    return this.store.state().payments.find(p => p.order.id === orderId);
  }

  getByOrderId(orderId: string): Payment | undefined {
    const dto = this.getDtoByOrderId(orderId);
    return dto ? new Payment(dto) : undefined;
  }
}
